import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDone32Icon } from '@gem/icons';

import { useFileDownloadStatePresenter } from 'APP/hooks/useFileDownloadState/useFileDownloadState';
import { UploaderState } from 'APP/main/ChatView/components/UploaderState/UploaderState';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import styles from './MediaUploadState.styles.m.css';

interface IVideoUploadStateProps {
  message: ChatMessage;
}

export const MediaUploadState: FC<IVideoUploadStateProps> = observer((props) => {
  const { message } = props;

  const presenter = useFileDownloadStatePresenter({
    payloadId: message.id,
    groupId: message.groupId,
    messageId: message.id,
  });

  return (
    <UploaderState
      className={styles.uploader}
      uploadFileData={{
        uploadProgress: message.payload.uploadProgress,
        cancelUpload: message.payload.cancelUploadAndDeleteMessage,
        hasError: message.hasError,
      }}
    >
      {message.isFake && !presenter.isWaitingDownloadProcess && !presenter.isDownloadInProcess ? (
        <IcDone32Icon className={styles.icon} />
      ) : null}
    </UploaderState>
  );
});
